import React from "react";
import { Link } from "react-router-dom";

import { viewerIcon } from "../../services/viewers";

import BackButton from "./BackButton";

import ViewerStyle from '../../css/Viewer.module.css';

export default function MenuCincoMinutos(props) {
    const { viewersCincoMinutos, handleShowFiveMinutes, handleButtonClick, activeMenuButton, dataViewers } = props;

    const renderViewersFiveMinutes = viewersCincoMinutos.map((viewer, i) => {
        const index = dataViewers.indexOf(viewer);
        const isActive = activeMenuButton === viewer.id;

        return (
            <Link key={viewer.id}
                to={`/visor-rpd/${viewer.slug}`}
                title={viewer.label}
                className={`${ViewerStyle["btn-month"]}${isActive ? ` ${ViewerStyle["active"]}` : ''}`}
                onClick={() => handleButtonClick(viewer.id, index)}>
                <ion-icon name={viewerIcon(viewer)}></ion-icon>
                <span>{viewer.label}</span>
            </Link>
        );
    });

    return (
        <>
            <BackButton onClick={handleShowFiveMinutes} />
            {renderViewersFiveMinutes}
        </>
    );
}